<script>
  export let idUnico = 'jesus';
  export let semlegenda = false;
  export let color;
  export let content;
  import navegacaoStore from '../../store';
  import { onMount } from 'svelte';
  import { location } from 'svelte-spa-router';

  let root;
  let grupos = [];
  let grupo = [];
  let botoes = [];
  let images = [];
  let dados;
  let splitImg;
  let li_begin;
  let legenda;
  let legendaBegin;
  let legendaEnd;

  let timestampTrick;
  let aux;

  timestampTrick = Date.now();

  navegacaoStore.subscribe((dadosStore) => {
    dados = dadosStore;
  });

  if ($location === '/' || Number($location.split('/')[1]) === 1) {
    aux = 0;
  } else {
    aux = Number($location.split('/')[1]) - 1;
  }

  legendaBegin = content.indexOf('<legenda>');
  if (legendaBegin != -1) {
    legendaEnd = content.indexOf('</legenda>');
    if (legendaEnd != -1) {
      legenda = content.substring(legendaBegin + '<legenda>'.length, legendaEnd);
      content = content.substring(0, legendaBegin);
    }
  }

  if (legenda.trim() == '') {
    semlegenda = true;
  }

  content = content.replace('Papaver somniferum', '<i>Papaver somniferum</i>');
  content = content.replace('ecstasy', '<i>ecstasy</i>');
  content = content.replace('Cannabis', '<i>Cannabis</i>');

  grupos = content.split(';;');

  grupos.forEach((element, index) => {
    if (element.trim() != '') {
      if (element.includes('::')) {
        grupo[index] = element.split('::');

        botoes[index] = grupo[index][0];

        li_begin = grupo[index][1].search('•');
        if (li_begin != -1) {
          grupo[index][1] = grupo[index][1].replaceAll('•', '<br><br>•&nbsp;&nbsp;');
        }

        splitImg = false;
      } else {
        botoes[index] = '';
        grupo[index] = element;
        splitImg = true;
        images[index] =
          dados.imagePath +
          'jesus_m' +
          dados.modulo +
          '_u' +
          aux +
          '_' +
          (index + 1) +
          '.jpg?timestamp=' +
          timestampTrick;
      }
    }
  });

  onMount(() => {
    if (color) {
      root.style.setProperty('--COR_MODULO', `var(--${color})`);
      root.style.setProperty('--COR_MODULO_FORTE', `var(--${color}_FORTE)`);
      root.style.setProperty('--COR_MODULO_FRACO', `var(--${color}_FRACO)`);
      root.style.setProperty('--COR_MODULO_SUPER_FRACO', `var(--${color}_SUPER_FRACO)`);
      root.style.setProperty('--HEX_MODULO_SUPER_FRACO', `var(--HEX_${color}_SUPER_FRACO)`);
      root.style.setProperty('--HEX_MODULO_FORTE', `var(--HEX_${color}_FORTE)`);
    }
    const slider = j$(`#${idUnico} .slider`);
    const itens = j$(`#${idUnico} .slider-container > div`);
    const conteudo = j$(`#${idUnico} .slider-content > div`);
    const panel = j$(`#${idUnico} .slider-content`);
    const numeroItens = itens.length - 1;
    const itemWidth = j$(itens[2]).width() + parseInt(j$(itens[1]).css('margin-left')) * 2;
    const middleWidth = slider.width() / 2 - itemWidth / 2;
    const contentHeight = set_same_height_collection(conteudo);

    j$(`#${idUnico} .slider-content`).css('height', contentHeight + 100);

    j$(slider.find('.slider-container > .edge')).css('width', `${middleWidth}px`);
    j$(slider.find('.slider-container')).css(
      'width',
      `${middleWidth * 2 + itemWidth * numeroItens + 2000}px`
    );

    function centerItVariableWidth(target, outer) {
      var out = j$(outer);
      var tar = j$(target);
      var x = out.width();
      var y = tar.outerWidth(true);
      var z = tar.index();
      var q = 0;
      var m = out.find('.slider-container > div');
      for (var i = 0; i < z; i++) {
        q += j$(m[i]).outerWidth(true);
      }
      out.animate({ scrollLeft: Math.max(0, q - (x - y + 10) / 2) }, 500);
    }

    // j$(conteudo[0]).addClass('active');
    // j$(itens[1]).addClass('active');

    centerItVariableWidth(itens[1], `#${idUnico} .slider`);
    j$.each(itens, (i, element) => {
      if (i > 0) {
        j$(element).click(() => {
          conteudo.removeClass('active');
          itens.removeClass('active');
          panel.removeClass('active');
          if (i % 2 === 1) {
            panel.css('background', 'var(--VERDE_CLARO_20)');
            panel.css('border', '2px solid var(--VERDE_CLARO)');
            // panel.css('color', 'var(--COR_MOD_PRI)');
          } else {
            // panel.css('background', '#7859a6');
            // panel.css('color', '#fff');
          }
          j$(conteudo[i - 1]).addClass('active');
          j$(itens[i]).addClass('active');
          j$(panel).addClass('active');
          centerItVariableWidth(element, `#${idUnico} .slider`);
        });
      }
    });
  });

  function isImage(element) {
    const ext = ['.png', '.svg', '.jpg', '.gif'];
    for (let e of ext) {
      if (element.toString().toLowerCase().indexOf(e) >= 0) {
        return true;
      }
    }
    return false;
  }
</script>

<div class="container" id={idUnico} bind:this={root}>
  <div class="row">
    <div class="col-md-10 mx-auto">
      <div class="slider">
        <div class="slider-container">
          <div class="edge" />
          {#each grupos as g, index}
            <div class={splitImg ? '' : 'js-number'}>
              {#if splitImg}
                <img src={images[index]} alt="Indice slider" />
              {:else}
                <h3>{g}</h3>
              {/if}
            </div>
          {/each}
        </div>
      </div>
      <div class="slider-content">
        {#each grupo as g, index}
          <div>
            {@html g}
          </div>
        {/each}
      </div>
    </div>
  </div>

  <div class="justify-content-center">
    {#if !semlegenda}
      <div class="legenda-wrapper">
        <div class="legenda">
          <!-- {descricao} -->
        </div>
        <div class="credito">
          <slot name="credito" />
          {legenda}
        </div>
      </div>
    {/if}
  </div>
</div>

<style>
  .clip-svg {
    /* clip-path: url('#myClip'); */
    /* border: 1px solid red; */
  }
  .slider {
    width: 100%;
    height: 150px;
    overflow-x: hidden;
    overflow-y: hidden;
    /* background: yellow; */
    /* margin-bottom: 25px; */
  }
  .slider-container {
    position: relative;
    /* height: 158px; */
    height: 140px;
    /* overflow-y: hidden; */
    align-items: center;
    display: flex;
    /* padding: 10px 0; */
  }
  .slider-container > :global(div:hover) {
    transform: scale(0.8);
  }
  .slider-container > :global(div) {
    position: relative;
    width: 120px;
    height: 120px;
    float: left;
    margin: 0 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 300ms ease;
    cursor: pointer;
    user-select: none;
    transform: scale(0.7);
    padding: 0;
  }
  .slider-container > :global(div.active::after) {
    content: '';
    width: 20px;
    height: 20px;
    background: var(--VERDE_CLARO);
    position: absolute;
    bottom: -20px;
    clip-path: polygon(0% 0%, 100% 0%, 50% 75%);
    clip-path: polygon(50% 10%, 100% 75%, 0% 75%);
  }

  .slider-container > :global(div.active) {
    width: 120px;
    height: 120px;
    transform: scale(1.1);
  }
  .slider-container > :global(div.active > h3) {
    color: var(--COR_BRANCO);
    /* font-size: 56px; */
    /* font-weight: 900; */
    /* margin-top: -5px; */
  }

  .slider-container > :global(div > img) {
    /* border-radius: 50%; */
    /* width: 93%; */
    filter: grayscale(0.6);
  }

  .slider-container > :global(div.active > img) {
    /* filter: drop-shadow(0 0 5px #333); */
    /* transform: scale(1.1); */
    /* border: 3px solid var(--COR_AZUL_1_S); */
    /* border: 5px solid var(--MARROM); */
    filter: drop-shadow(0 0 3px #00000055);
  }

  .slider-container > :global(div.active .path-icon) {
    fill: var(--COR_LARANJA_P);
  }

  .slider-container > :global(div .path-icon) {
    fill: var(--COR_LARANJA_50);
  }

  .slider-content :global(h4) {
    color: #559c92;
    font-family: var(--FONT_INTER);
    font-style: normal;
    font-size: 28px;
    margin-bottom: 0.5rem;
  }
  .slider-content > div {
    color: var(--COR_FONT);
  }
  .slider-content > div :global(span) {
    color: var(--MARROM);
    font-weight: 700;
  }
  .slider-container > :global(div > h3) {
    margin: 0;
    padding: 0;
    font-size: 64px;
    font-weight: 700;
    /* color: var(--COR_AZUL_1_S); */
    color: var(--COR_BRANCO);
    font-family: var(--FONT_INTER);
    /* margin-top: -1rem; */
    /* margin-left: -9px; */
    z-index: 1;
  }

  .slider-container > :global(div > img) {
    max-width: 100%;
    max-height: 100%;
    /* border: 1px solid var(--MARROM); */
    /* border-radius: 50%; */
    padding: 0px;
  }

  .slider::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 150px;
    top: 0;
    left: 0;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 0) 70%,
      rgba(255, 255, 255, 1) 100%
    );
    pointer-events: none;
    /* background: rgba(255, 0, 0, 0.5); */
  }

  .slider-container > .edge {
    all: unset;
    background: rgba(255, 255, 255, 0);
  }

  .slider-content {
    background: var(--VERDE_CLARO_20);
    /* box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.1); */
    border-radius: 15px;
    color: var(--COR_MOD_PRI);
    padding: 30px 45px;
    font-family: var(--FONT_INTER);
    margin-top: 0;
    font-weight: 500;
    /* display: none; */
    border: 2px solid var(--VERDE_CLARO_60);
  }

  .slider-content:global(.active) {
    background: var(--VERDE_CLARO_20);
    text-wrap: pretty;
  }

  .slider-content > :global(div b) {
    font-size: 20px;
    margin-bottom: 10px;
    display: block;
    font-weight: 700;
    color: var(--MARROM);
    text-align: center;
  }
  .slider-content > :global(div) {
    display: none;
  }
  .slider-content > :global(div.active) {
    display: block;
  }

  .bkg-icon {
    position: absolute;
    left: 0;
    /* top: 10px; */
    top: 0px;
    width: 113px;
  }

  .legenda-wrapper {
    --Gradientes-Degrad-principal: linear-gradient(to right, #33cfb9, #b62ca2);
    --Gradientes-Degrad-principal-inv: linear-gradient(
      to left,
      var(--COR_MOD_TER),
      var(--COR_MOD_PRI)
    );
    --Principais-Texto: #000000;
    --cor-primaria: #b62ca2;
    --cor-secundaria: #33cfb9;
    --Infogrficos-Cinza: #e1e4e5;
    --Infogrficos-Cinza: #fff;
    color: var(--Principais-Verde-mdio, #559c92);
    color: var(--COR_MOD_TER);
    text-align: right;
    font-family: Lora;
    font-size: 14px;
    font-style: italic;
    font-weight: 500;
    border-radius: 0 0 35px 0px;
    padding: 10px 30px 10px 30px;
    border-right: 2px solid transparent;
    border-bottom: 2px solid transparent;
    background-image: linear-gradient(var(--Infogrficos-Cinza), var(--Infogrficos-Cinza)),
      var(--Gradientes-Degrad-principal-inv);
    background-origin: border-box;
    background-clip: padding-box, border-box;
    line-height: normal;
    text-wrap-style: pretty;
    position: relative;
    z-index: 2;
    margin-top: 15px;
  }
  .legenda-wrapper:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background: linear-gradient(to bottom, #f2f2f2, white); */
    /* background: white; */
    z-index: -1;
    border-radius: 0 0 32px 0;
  }

  @media (max-width: 767px) {
    .slider-container > :global(div) {
      margin: 0 10px;
    }
    .container {
      padding: 0;
      /* margin: 0; */
      width: 100%;
    }
    .slider-content {
      margin: 0 15px 0 15px;
      padding: 20px 20px;
    }
    .slider-content :global(h4) {
      font-size: 24px;
    }
    .slider-content > div {
      line-height: 1.4;
      font-size: 17px;
    }
    .legenda-wrapper {
      width: calc(100% - 30px);
      left: 15px;
    }
    .legenda-wrapper:before {
      /* left: 15px;
      width: calc(100% - 30px); */
    }
  }
</style>
